/*
 * @Author: Chao Yang
 * @Date: 2020-03-09 11:11:36
 * @LastEditor: Chao Yang
 * @LastEditTime: 2021-03-15 02:03:08
 */
import { Injectable } from '@angular/core';
import { parse } from 'date-fns';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as Account from 'src/app/domain/model/account/index';
import { TaskProxy } from 'src/app/domain/proxy/index';
import * as IDtoAccountGroup from 'src/app/domain/model/account-group/index';

@Injectable()
export class TaskService {
  constructor(private _taskProxy: TaskProxy) {}

  createUserResponse(
    id: number,
    yesOrNo: boolean,
    comment: string
  ): Observable<number[]> {
    return this._taskProxy.createUserResponse({
      id,
      yesOrNo,
      comment,
    });
  }

  getProgramTask(
    programId: number,
    accounts: IDtoAccountGroup.IAccountItem[]
  ): Observable<Account.ITask[]> {
    return this._taskProxy.getProgramTask(programId, accounts).pipe(
      map((tasks) => {
        tasks.forEach((task) => {
          task.due = parse(task.dueDate, 'yyyy-MM-dd', new Date());
        });
        return tasks;
      })
    );
  }

  getTasks(
    accounts: IDtoAccountGroup.IAccountItem[]
  ): Observable<Account.ITask[]> {
    return this._taskProxy.getTasks(accounts).pipe(
      map((tasks) => {
        tasks.forEach((task) => {
          task.due = parse(task.dueDate, 'yyyy-MM-dd', new Date());
        });
        return tasks;
      })
    );
  }
}
